import Vue from "vue";
import ImageUpload from "@/components/Image/ImageUpload";
import ViewImage from "@/components/Image/ViewImage";
import DateMenu from "@/components/Fields/DateMenu";
import DateField from "@/components/Fields/DateField";
import DatePeriod from "@/components/Fields/DatePeriod";
import DateOfBirth from "@/components/Fields/DateOfBirth";
import MobileField from "@/components/Fields/MobileField";
import ConfirmModel from "@/components/Confirmation/ConfirmModel";

Vue.component("image-upload", ImageUpload);
Vue.component("view-image", ViewImage);
Vue.component("date-menu", DateMenu);
Vue.component("date-field", DateField);
Vue.component("date-period", DatePeriod);
Vue.component("date-of-birth", DateOfBirth);
Vue.component("mobile-field", MobileField);
Vue.component("confirm-model", ConfirmModel);

export default Vue.component;
